import {
  List,
  Datagrid,
  TextField,
  BooleanField,
  NumberField,
  DateField,
  EditButton,
  DeleteButton,
  CreateButton,
  TopToolbar,
  FilterButton,
  SearchInput,
  BooleanInput,
  SelectInput,
  ReferenceField,
  ReferenceInput,
  UrlField,
} from 'react-admin';

const VacancyListActions = () => (
  <TopToolbar>
    <FilterButton />
    <CreateButton />
  </TopToolbar>
);

const vacancyFilters = [
  <SearchInput source="search" alwaysOn />,
  <ReferenceInput source="categoryId" reference="vacancy-categories">
    <SelectInput optionText="name" />
  </ReferenceInput>,
  <SelectInput 
    source="employment" 
    choices={[
      { id: 'FULL_TIME', name: 'Полная занятость' },
      { id: 'PART_TIME', name: 'Частичная занятость' },
    ]}
  />,
  <BooleanInput source="isActive" />,
];

export const VacancyList = () => (
  <List
    filters={vacancyFilters}
    actions={<VacancyListActions />}
    sort={{ field: 'sortOrder', order: 'ASC' }}
  >
    <Datagrid>
      <TextField source="title" />
      <ReferenceField source="categoryId" reference="vacancy-categories">
        <TextField source="name" />
      </ReferenceField>
      <TextField source="employment" />
      <TextField source="experience" />
      <TextField source="salary" />
      <BooleanField source="isActive" />
      <NumberField source="sortOrder" />
      <UrlField source="externalUrl" />
      <DateField source="createdAt" showTime />
      <EditButton />
      <DeleteButton mutationMode="pessimistic" />
    </Datagrid>
  </List>
);
